import React, { useState } from 'react';
import { Link } from 'react-router-dom';


export const CRUDRootHeaderButton = ({ title, btnText, btnOnClick }) => {
    const [toggle, setToggle] = useState(false);
    return (
        <div className="row page-header">
            <div className="columns small-9">
                <h1 className="page__title">{title}</h1>
            </div>
            <div className="columns small-3 dropdown">
                <button onClick={() => setToggle(!toggle)} className="button large expanded">{btnText}</button>
                <div className={`dropdown-content ${toggle ? "show" : ""}`}>
                    <Link to="/articles/create">Article</Link>
                    <Link to="/employees/create">Employee</Link>
                </div>
            </div>
        </div>
    );
}